import { render, staticRenderFns } from "./VueBootstrap4Table.vue?vue&type=template&id=4fa704a2&scoped=true"
import script from "./VueBootstrap4Table.vue?vue&type=script&lang=js"
export * from "./VueBootstrap4Table.vue?vue&type=script&lang=js"
import style0 from "./VueBootstrap4Table.vue?vue&type=style&index=0&id=4fa704a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa704a2",
  null
  
)

export default component.exports